<h2 mat-dialog-title>Delete Question:</h2>
<mat-dialog-content class="mat-dialog-content"><h3>{{ dialogTitle }}</h3>
    <p>{{text}}</p></mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions right">
    <button [mat-dialog-close]="true" class="spaced_button" color="primary" mat-raised-button id="FaqDeleteYes">Yes</button>
    <button [mat-dialog-close]="false" color="primary" mat-raised-button id="FaqDeleteNo">No</button>
</mat-dialog-actions>
